import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BookingIDSubmitButtonClick } from '../utils/Analytics';
import { baseURL } from "../constants/Api";


function EnterBookinngModal(props) {
  const [bookingId, setBookingId] = useState("");
  const [Error,SetError] = useState("");
  const [loading, setlLoading] = useState(false);
  const navigate = useNavigate();

  // Close modal
  const closeModal = () => {
    props.hide();
  };

  // Handle booking ID input change
  const handleBookingId = (e) => {
    setBookingId(e.target.value);
  };

  let data;

    const initialCheck =()=>{
      if (bookingId) {
        localStorage.setItem("guestBookingId", bookingId);
      }
    
      if (bookingId) {
        const mobileNumber = localStorage.getItem("phone_no");
        const email = localStorage.getItem("guest_email");
    
        if (mobileNumber) {
          data = {
            bookingId: bookingId,
            mobileNumber,
          };
        } else if (email) {
          data = {
            bookingId: bookingId,
            email,
          };
        }
    }
  }

    useEffect(()=>{
      initialCheck()
    },[bookingId])
    
    // Handle booking ID submission
    const submitBookingId = async () => {
      BookingIDSubmitButtonClick();

      if (bookingId !== "") {
        try {
          setlLoading(true);
          const response = await axios.post(`${baseURL}/api/bookingIdV21`, data, {
            headers: { "Content-Type": "application/json" },
          });
          if (response.data.success) {
            setlLoading(false);
            let bookingArray = JSON.parse(localStorage.getItem("BookingIDDetailsArray")) || [];
            const existingBooking = bookingArray.find(item => item.reservationDetails.bookingId === response.data.data.reservationDetails.bookingId);
            if (!existingBooking) {
              const newBooking = {
                reservationDetails: response.data.data.reservationDetails,
                hoteldetails: response.data.data.hotelDetails
            };
            bookingArray.push(newBooking);
              localStorage.setItem("BookingIDDetailsArray", JSON.stringify(bookingArray));
            }   
          navigate("../home", {
            state: {
              data: response?.data.data,
              
            },
          });
          } else {
            setlLoading(false);
            SetError("Invalid Booking Id");
            localStorage.removeItem("restrictHotelListFlag");
          }
        } catch (error) {
          setlLoading(false);
          console.error("Error submitting booking ID:", error);
        }
      }
    };

    return (
      <>
        <Transition appear show={true} as={Fragment}>
          <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0">
              <div className="fixed inset-0 bg-black/25" />
            </Transition.Child>
            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95">
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-[#171538] p-6 py-9 text-left align-middle shadow-xl transition-all absolute top-[24%]">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900"></Dialog.Title>
                    <div className="doc-modal flex-col items-center justify-center mt-2">
                      <div className="flex justify-center items-center"></div>
                      <div className="text-xs text-white mb-2">
                        Please Enter your Booking Id
                      </div>
                      <input
                        onChange={handleBookingId}
                        type="text"
                        placeholder="Your Hotel Booking Id"
                        className="px-3"/>
                      <button onClick={submitBookingId} className="booking-submit-btn w-full mt-4 flex items-center justify-center">
                          <span>Enter</span>
                           {loading ? <span className="loader ml-2"></span> : null}
                      </button>
                      {Error && (
                      <div className="w-full flex justify-center">
                        <div className="error-doc text-center mt-3">
                          {Error}
                        </div>
                      </div>
                    )}
                    </div>
                    <div className="absolute top-2 right-2">
                      <button
                        type="button"
                        className="outline-none rounded-full hover:bg-gray-600"
                        onClick={closeModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1" stroke="white" className="w-6 h-6">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </>
    );
  
}

export default EnterBookinngModal;
